/**
 * 10 液位监控 17:30以前T+1,17:30以前T+2
 * 20 24小时 15:00以前T+1,17:30以前T+2
 * 30 36小时 15:00以前T+1,17:30以前T+2
 * 40 48小时 17:30以前T+2,17:30以前T+3
 * 50 72小时 17:30以前T+3,17:30以前T+4
 * 60 其它 17:30以前T+2,17:30以前T+3
 * 999 无信息 17:30以前T+2,17:30以前T+3
 */

const DayObj: { [key: string]: TimeDisabledDateInfo } = {
  "10": {
    minDays: 1,
    maxDays: 2,
    hour: 17,
    minute: 30,
    msg: "48小时",
  },
  "20": {
    minDays: 1,
    maxDays: 2,
    hour: 15,
    minute: 0,
    msg: "24小时",
  },
  "30": {
    minDays: 1,
    maxDays: 2,
    hour: 15,
    minute: 0,
    msg: "36小时",
  },
  "40": {
    minDays: 2,
    maxDays: 3,
    hour: 17,
    minute: 30,
    msg: "48小时",
  },
  "50": {
    minDays: 3,
    maxDays: 4,
    hour: 17,
    minute: 30,
    msg: "72小时",
  },
  "60": {
    minDays: 2,
    maxDays: 3,
    hour: 17,
    minute: 30,
    msg: "72小时",
  },
  "888": {
    //配送方式为自提
    minDays: 0,
    maxDays: 0,
    hour: 0,
    minute: 0,
    msg: "24小时",
  },
  "999": {
    minDays: 2,
    maxDays: 3,
    hour: 17,
    minute: 30,
    msg: "72小时",
  },
};
export default DayObj;
